module.exports = __webpack_public_path__ + "media/images/apple-touch-icon-76x76-precomposed-525b7c49ca6f092ef96d207df051981b.png";